import { ISectionsVisibility } from 'api/types';
import { createSelector } from 'reselect';

import { civilSectionAcademicYearsDataSelector } from './civil/civilSectionAcademicYearsDataSelector';
import { creationSectionAcademicYearsDataSelector } from './creation/creationSectionAcademicYearsDataSelector';
import { cultureSectionAcademicYearsDataSelector } from './culture/cultureSectionAcademicYearsDataSelector';
import { professionSectionAcademicYearsDataSelector } from './profession/professionSectionAcademicYearsDataSelector';
import { profileEmptyDataMapSelector } from './profile/profileEmptyDataMapSelector';
import { scienceSectionAcademicYearsDataSelector } from './science/scienceSectionAcademicYearsDataSelector';
import { sportSectionAcademicYearsDataSelector } from './sport/sportSectionAcademicYearsDataSelector';
import { studySectionAcademicYearsDataSelector } from './study/studySectionAcademicYearsDataSelector';

export const disabledDisplaySettingsSelector = createSelector(
  [
    // Данные раздела учёба
    studySectionAcademicYearsDataSelector,
    // Данные раздела наука
    scienceSectionAcademicYearsDataSelector,
    // Данные раздела спорт
    sportSectionAcademicYearsDataSelector,
    // Данные раздела творчество
    creationSectionAcademicYearsDataSelector,
    // Данные раздела культура
    cultureSectionAcademicYearsDataSelector,
    // Данные раздела гражданская активность
    civilSectionAcademicYearsDataSelector,
    // Данные раздела моя профессия
    professionSectionAcademicYearsDataSelector,
    // Данные раздела Обо мне
    profileEmptyDataMapSelector,
  ],
  (
    // Учеба
    studySectionAcademicYearsData,
    // Наука
    scienceSectionAcademicYearsData,
    // Спорт
    sportSectionAcademicYearsData,
    // Творчество
    creationSectionAcademicYearsData,
    // Культура
    cultureSectionAcademicYearsData,
    // Гражданская активность
    civilSectionAcademicYearsData,
    // Моя профессия
    professionSectionAcademicYearsData,
    // Обо мне
    profileEmptyDataMap,
  ) => {
    const disabledSections: Record<keyof ISectionsVisibility, boolean> = {
      studentData: false,

      // Обо мне
      ...profileEmptyDataMap,
      // Учеба
      ...studySectionAcademicYearsData.emptyDataMap,
      // Наука
      ...scienceSectionAcademicYearsData.emptyDataMap,
      // Спорт
      ...sportSectionAcademicYearsData.emptyDataMap,
      // Творчество
      ...creationSectionAcademicYearsData.emptyDataMap,
      // Культура
      ...cultureSectionAcademicYearsData.emptyDataMap,
      // Гражданская активность
      ...civilSectionAcademicYearsData.emptyDataMap,
      // Моя профессия
      ...professionSectionAcademicYearsData.emptyDataMap,
    };

    return disabledSections;
  },
);
